import { ValueProvider } from '@angular/core';
import { FONTS_TO_LOAD, FontsToLoad } from '@shared/tokens';

export const defaultFontsToLoad = [
	{ family: 'NeueHaasGroteskDisplay', fileName: 'NeueHaasDisplay-Light.woff', descriptors: { weight: '400' } },
	{ family: 'NeueHaasGroteskDisplay', fileName: 'NeueHaasDisplay-Roman.woff', descriptors: { weight: '450' } },
	{ family: 'NeueHaasGroteskDisplay', fileName: 'NeueHaasDisplay-Medium.woff', descriptors: { weight: '500' } }
] as const;

export const provideFontsToLoad = (fontsToLoad: Readonly<FontsToLoad> = defaultFontsToLoad): ValueProvider[] => [
	{
		provide: FONTS_TO_LOAD,
		useValue: fontsToLoad
	} satisfies Omit<ValueProvider, 'useValue'> & { useValue: Readonly<FontsToLoad> }
];
